var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import { getErrorMessage } from "../../../utilities/axios-utility";
import { errorSnackbar } from "../../../shared/snackbar-constants";
export var PayPalPage = function (_a) {
    var paymentSessionId = _a.paymentSessionId, geoData = _a.geoData, setPaymentResult = _a.setPaymentResult, setPaymentResultOpened = _a.setPaymentResultOpened, setPaymentInProgress = _a.setPaymentInProgress, api = _a.api, clientId = _a.clientId, currency = _a.currency;
    var processorCommonCode = "PAYPAL_APM";
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var initialOptions = {
        clientId: clientId,
        currency: currency,
    };
    var createOrder = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        processorCommonCode: processorCommonCode,
                        paymentSessionId: paymentSessionId,
                    };
                    setPaymentInProgress(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.OpenPayment(request)];
                case 2:
                    response = _a.sent();
                    if (response.data.code == "200000") {
                        return [2 /*return*/, response.data.detail.additionalData.paypalOrderId];
                    }
                    enqueueSnackbar(getErrorMessage(response), errorSnackbar);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setPaymentInProgress(false);
                    enqueueSnackbar(getErrorMessage(error_1), errorSnackbar);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onError = function (err) {
        setPaymentInProgress(false);
    };
    var onApprove = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var request, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        processorCommonCode: processorCommonCode,
                        paymentSessionId: paymentSessionId,
                        paypalOrderId: data.orderID,
                    };
                    setPaymentInProgress(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setPaymentResultOpened(true);
                    return [4 /*yield*/, api.OpenPayment(request)];
                case 2:
                    response = _a.sent();
                    setPaymentResult(response.data);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    setPaymentInProgress(false);
                    enqueueSnackbar(getErrorMessage(error_2), errorSnackbar);
                    return [3 /*break*/, 4];
                case 4:
                    setPaymentInProgress(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", { children: _jsx(PayPalScriptProvider, __assign({ options: initialOptions }, { children: _jsx(PayPalButtons, { onApprove: onApprove, createOrder: createOrder, onError: onError }) })) }));
};
